import { Component, Directive, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({ selector: '[uwThreeColumnMicroLayoutRight]' })
export class ThreeColumnMicroLayoutRightDirective { }

@Directive({ selector: '[uwThreeColumnMicroLayoutMiddle]' })
export class ThreeColumnMicroLayoutMiddleDirective { }

@Directive({ selector: '[uwThreeColumnMicroLayoutLeft]' })
export class ThreeColumnMicroLayoutLeftDirective { }

@Component({
    selector: 'uw-three-column-micro-layout',
    templateUrl: './three-column-micro-layout.component.html',
    styleUrls: ['./three-column-micro-layout.component.scss']
})
export class ThreeColumnMicroLayoutComponent {

}

@NgModule({
    exports: [
        ThreeColumnMicroLayoutComponent,
        ThreeColumnMicroLayoutLeftDirective,
        ThreeColumnMicroLayoutRightDirective,
        ThreeColumnMicroLayoutMiddleDirective
    ],
    imports: [
        CommonModule,
        ThreeColumnMicroLayoutComponent,
        ThreeColumnMicroLayoutLeftDirective,
        ThreeColumnMicroLayoutRightDirective,
        ThreeColumnMicroLayoutMiddleDirective
    ]
})
export class ThreeColumnMicroLayoutModule { }
